<template>
  <div class="flex items-center bg-cosmicPurple/10 rounded-md p-1">
    <button
      @click="setView('list')"
      :title="'List view'"
      :class="[
        'px-3 py-1 rounded-sm text-sm transition-all duration-200',
        currentView === 'list'
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
      ]"
    >
      <List class="w-4 h-4" />
    </button>
    <button
      @click="setView('table')"
      :title="'Table view'"
      :class="[
        'px-3 py-1 rounded-sm text-sm transition-all duration-200',
        currentView === 'table'
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
      ]"
    >
      <Table class="w-4 h-4" />
    </button>
    <button
      @click="setView('kanban')"
      :title="'Kanban view'"
      :class="[
        'px-3 py-1 rounded-sm text-sm transition-all duration-200',
        currentView === 'kanban'
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
      ]"
    >
      <Columns3 class="w-4 h-4" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { List, Table, Columns3 } from 'lucide-vue-next'

const props = defineProps<{
  currentView: 'list' | 'table' | 'kanban'
}>()

const emit = defineEmits<{
  'update:view': [view: 'list' | 'table' | 'kanban']
}>()

const setView = (view: 'list' | 'table' | 'kanban') => {
  emit('update:view', view)
}
</script>
